<svelte:options tag="edi-svg-add" />

<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
	<rect opacity="0.2" width="32.004" height="32" rx="4" fill="#1DCD98" />
	<path
		d="M21.777 14.5564H17.4456V10.2256C17.4456 9.69416 17.0146 9.26318 16.4831 9.26318H15.5206C14.9891 9.26318 14.5581 9.69416 14.5581 10.2256V14.5564H10.2267C9.69519 14.5564 9.26416 14.9874 9.26416 15.5188V16.4812C9.26416 17.0127 9.69519 17.4436 10.2267 17.4436H14.5581V21.7745C14.5581 22.3059 14.9891 22.7369 15.5206 22.7369H16.4831C17.0146 22.7369 17.4456 22.3059 17.4456 21.7745V17.4436H21.777C22.3085 17.4436 22.7395 17.0127 22.7395 16.4812V15.5188C22.7395 14.9874 22.3085 14.5564 21.777 14.5564Z"
		fill="#1DCD98"
	/>
</svg>
